module.exports = __webpack_public_path__ + "img/2beae91.jpg";